import { Briefcase, BarChart, CheckCircle, TrendingUp, FileText, DollarSign, ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";

export default function Franchaise() {
  const services = [
    { icon: <Briefcase className="w-6 h-6 text-blue-600" />, title: "Business & Tax Consulting", desc: "Strategic planning to optimize growth and tax efficiency." },
    { icon: <BarChart className="w-6 h-6 text-blue-600" />, title: "Financial Analysis & Reporting", desc: "Comprehensive reviews to enhance profitability." },
    { icon: <CheckCircle className="w-6 h-6 text-blue-600" />, title: "Management Accounting", desc: "Tailored solutions for operational efficiency." },
    { icon: <FileText className="w-6 h-6 text-blue-600" />, title: "Regulatory Compliance Support", desc: "Ensuring adherence to industry standards." },
    { icon: <TrendingUp className="w-6 h-6 text-blue-600" />, title: "Tax Optimization Strategies", desc: "Implementing the best structures to minimize tax liabilities." },
    { icon: <DollarSign className="w-6 h-6 text-blue-600" />, title: "Capital Raising & Financing", desc: "Assisting with funding and investment opportunities." },
  ];

  return (
    <div className="w-full">
      {/* Hero Section */}
      <section
        className="relative text-center w-full h-[600px] lg:h-[700px] flex items-center justify-center"
        style={{
          backgroundImage: "url('images/bg4.jpeg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="absolute inset-0 flex flex-col items-center justify-center bg-black bg-opacity-50 text-white px-6">
          <h1 className="text-4xl md:text-6xl lg:text-8xl font-bold mb-4">Franchise Accounting</h1>
          <p className="text-lg md:text-2xl lg:text-3xl max-w-4xl text-gray-400">
            Simplifying taxes involved in Franchised, and maximizing profits – your trusted accounting partner!
          </p>
        </div>
      </section>

      {/* Main Content Section */}
      <div className="bg-slate-900 py-12 px-6 md:px-16">
        <div className="flex flex-wrap items-center justify-center gap-12 max-w-7xl mx-auto">
          {/* Text Content */}
          <div className="text-center max-w-3xl lg:max-w-4xl">
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-100">
              Franchise Accounting & Advisory
            </h2>
            <p className="text-lg md:text-xl text-gray-400 mt-6 text-justify">
              As a Business Consulting and Management Accounting Practice, our firm understands the challenges of the franchise industry. We are dedicated to delivering a broad range of Franchise Businesses such as; Restaurants, Retail, Travel & Accommodation, and other Specialty Businesses.
            </p>
            <p className="text-lg md:text-xl text-gray-400 mt-4 text-justify">
              Unlock the full potential of your franchise with our expert accounting and advisory services. We specialize in managing franchise finances, ensuring compliance, and optimizing profitability. From bookkeeping and tax planning to strategic financial guidance, we provide tailored solutions to help your franchise thrive. Partner with us for seamless financial management and informed decision-making, so you can focus on growing your business with confidence.
            </p>
            <div className="flex mt-6 justify-center">
                             <Link to="/contactus">
              <button className="flex items-center gap-2 bg-amber-300 text-black p-3 px-6 text-lg font-semibold hover:bg-amber-600 transition">
                Schedule A Call
                <ArrowUpRight size={20} />
              </button></Link>
            </div>
          </div>

          {/* Service Cards Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 mt-10 max-w-6xl mx-auto">
            {services.map((service, index) => (
              <div key={index} className="bg-white p-6 shadow-md rounded-lg hover:shadow-lg transition-all">
                <div className="flex items-center space-x-3">
                  {service.icon}
                  <h3 className="text-xl font-semibold text-gray-800">{service.title}</h3>
                </div>
                <p className="text-gray-600 mt-2">{service.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

// import { Briefcase, BarChart, CheckCircle, TrendingUp, FileText, DollarSign, ArrowUpRight } from "lucide-react";

// export default function Franchaise() {
//   const services = [
//     { icon: <Briefcase className="w-6 h-6 text-blue-600" />, title: "Business & Tax Consulting", desc: "Strategic planning to optimize growth and tax efficiency." },
//     { icon: <BarChart className="w-6 h-6 text-blue-600" />, title: "Financial Analysis & Reporting", desc: "Comprehensive reviews to enhance profitability." },
//     { icon: <CheckCircle className="w-6 h-6 text-blue-600" />, title: "Management Accounting", desc: "Tailored solutions for operational efficiency." },
//     { icon: <FileText className="w-6 h-6 text-blue-600" />, title: "Regulatory Compliance Support", desc: "Ensuring adherence to industry standards." },
//     { icon: <TrendingUp className="w-6 h-6 text-blue-600" />, title: "Tax Optimization Strategies", desc: "Implementing the best structures to minimize tax liabilities." },
//     { icon: <DollarSign className="w-6 h-6 text-blue-600" />, title: "Capital Raising & Financing", desc: "Assisting with funding and investment opportunities." },
//   ];

//   return (
//     <div>
//          {/* Hero Section */}
//       <section
//         className="relative text-center w-full h-[600px]"
//         style={{
//           backgroundImage: "url('images/bg4.jpeg')",
//           backgroundSize: "cover",
//           backgroundPosition: "center",
//           backgroundRepeat: "no-repeat",
//         }}
//       >
//         <div className="absolute inset-0 flex flex-col items-center justify-center bg-black bg-opacity-50 text-white p-6">
//           <h1 className="text-4xl font-bold mb-4 md:text-8xl">Franchise Accounting </h1>
//           <p className="text-lg max-w-3xl text-gray-400 md:text-3xl">
//           Simplifying taxes involved in Franchised, and maximizing profits – your trusted accounting partner!.
//           </p>
//         </div>
//       </section>

//     <div className= "flex bg-slate-900 py-12 px-6 md:px-16">
//         {/* <div>
//             <img className="h-[500px]" src="images/profesional.webp"></img>
//         </div> */}
// <div className=" flex   items-center justify-between gap-12 mt-20 mb-20">
//       <div className=" text-center gap-12 max-w-4xl">
//         <h2 className="text-4xl md:text-6xl font-bold text-gray-100 ">Franchise Accounting <br/>& Advisory</h2>
//         <p className="text-2xl text-gray-400 mt-12 text-justify ">As a Business Consulting and Management Accounting Practice, 
//             our firm understands the challenges of the franchise industry. We are dedicated to delivering a broad 
//             range of Franchise Businesses such as; Restaurants, Retail, Travel & Accommodation, and other Specialty Businesses.
//              Our Services include;.</p>

//              {/* <p className="text-4xl font-bold text-gray-100 mt-12">Simplifying taxes involved in Franchised, and maximizing profits – your trusted accounting partner!</p> */}
//              <p className="text-2xl text-gray-400 mt-4  text-justify">Unlock the full potential of your franchise with our expert accounting and advisory services. We specialize in managing franchise finances, ensuring compliance, and optimizing profitability. From bookkeeping and tax planning to strategic financial guidance, we provide tailored solutions to help your franchise thrive. Partner with us for seamless financial management 
//                 and informed decision-making, so you can focus on growing your business with confidence. </p>
 
//  <div className="flex mt-6 justify-center">
//  <button className="flex items-center gap-2 bg-amber-300 text-black p-3 px-6 text-lg font-semibold hover:bg-amber-600 transition">
//     Schedule A Call
//     <ArrowUpRight size={20} />
//   </button>
//  </div>
//       </div>

//       <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mt-10 max-w-3xl mx-auto">
//         {services.map((service, index) => (
//           <div key={index} className="bg-white p-6 shadow-md rounded-lg hover:shadow-lg transition-all">
//             <div className="flex items-center space-x-3">
//               {service.icon}
//               <h3 className="text-xl font-semibold text-gray-800">{service.title}</h3>
//             </div>
//             <p className="text-gray-600 mt-2">{service.desc}</p>
//           </div>
//         ))}
// </div>
// </div>
//     </div>
//     </div>

//   );
// }
